import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../logo.png';

export default function ComingSoon({ message, chessAllowed }) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
            <img src={logo} alt="Iyanna Foundation" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          </div>
        <div style={styles.eyebrow}>IYANNA FOUNDATION</div>
        <div style={styles.title}>Coming Soon</div>
        <div style={styles.message}>
          {message || 'Tunafanya maboresho kwenye mfumo wetu ili kuhakikisha taarifa za jamii yetu zinalindwa vizuri zaidi. Tutarudi hivi karibuni.'}
        </div>
        <div style={styles.subMessage}>
          We're making improvements to better protect our community's information. We'll be back shortly.
        </div>

        {chessAllowed && (
          <Link to="/chess" style={styles.chessBtn}>
            Chess bado inafanya kazi — Bofya hapa
          </Link>
        )}

        {/* Staff na Admin lazima waweze kuingia hata wakati wa matengenezo,
            vinginevyo hakuna wa kuzima hali hii. */}
        <Link
          to="/login"
          style={{
            display: 'inline-block', marginTop: '22px',
            color: 'rgba(255,255,255,0.55)', fontSize: '12.5px',
            fontWeight: 600, textDecoration: 'none',
            borderBottom: '1px solid rgba(255,255,255,0.25)',
            paddingBottom: '2px',
          }}
        >
          Admin / Staff Portal
        </Link>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(160deg, #041F14 0%, #07271A 40%, #14452F 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
  card: {
    maxWidth: '440px',
    width: '100%',
    textAlign: 'center',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '24px',
    padding: '40px 30px',
  },
  logo: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    background: '#041F14',
    padding: '0px',
    border: '2px solid rgba(255,255,255,0.15)',
    marginBottom: '18px',
    objectFit: 'cover', overflow: 'hidden'},
  eyebrow: {
    color: '#FFA726',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '1.5px',
    marginBottom: '10px',
  },
  title: {
    color: '#fff',
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '30px',
    marginBottom: '16px',
  },
  message: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '14.5px',
    lineHeight: 1.7,
    marginBottom: '10px',
  },
  subMessage: {
    color: 'rgba(255,255,255,0.4)',
    fontSize: '12.5px',
    lineHeight: 1.6,
    fontStyle: 'italic',
    marginBottom: '24px',
  },
  chessBtn: {
    display: 'inline-block',
    background: 'linear-gradient(135deg, #F57C00, #FFA726)',
    color: '#fff',
    textDecoration: 'none',
    padding: '13px 26px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '700',
  },
};
